import {
  IPartnerCreateParams,
  IPartnerUpdateParams,
  PartnerStatus,
} from "~/entity/Partners/model/schema";
import { IPartnersForm } from "~/pages/Partners/PartnersFormModal";
import { buildFullAddress } from "~/shared/lib/addressGeo";

import { mapPartnerStatusToApi } from "./partnerStatus";

const toGeoSelections = (data: IPartnersForm) => ({
  country: data.country,
  fo: data.fo,
  subject: data.region,
  district: data.district,
  city: data.city,
  locality: data.locality,
  street: data.street,
  house: data.house,
});

const mapLocationFields = (data: IPartnersForm) => {
  const mergedAddress = buildFullAddress(toGeoSelections(data)).trim();

  return {
    country: data.country?.name || undefined,
    federalDistrict: data.fo?.name || undefined,
    region: data.region?.name || undefined,
    city: data.city?.name || undefined,
    locality: data.locality?.name || undefined,
    street: data.street?.name || undefined,
    house: data.house?.name || undefined,
    zipCode: data.house?.index || undefined,
    address: mergedAddress || undefined,
  };
};

export const mapPartnerFormToCreateParams = (
  data: IPartnersForm,
  createdBy?: number,
): IPartnerCreateParams => ({
  name: data.name.trim(),
  inn: data.inn.trim() || undefined,
  status: mapPartnerStatusToApi(data.status.value as PartnerStatus),
  createdBy,
  ...mapLocationFields(data),
});

export const mapPartnerFormToUpdateParams = (
  data: IPartnersForm,
): IPartnerUpdateParams => ({
  name: data.name.trim(),
  inn: data.inn.trim() || undefined,
  status: mapPartnerStatusToApi(data.status.value as PartnerStatus),
  ...mapLocationFields(data),
});
